import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { messageProviderInjectionKey as k } from "./context.js";
import { messageProps as L } from "./message-props.js";
import O from "./styles/index.cssr.js";
import K from "../../_mixins/use-config.js";
import { useRtl as D } from "../../_mixins/use-rtl.js";
import F from "../../_mixins/use-theme.js";
import { createKey as c } from "../../_utils/cssr/index.js";
import { useThemeClass as q } from "../../_mixins/use-css-vars-class.js";
import A from "../../_internal/icon-switch-transition/src/IconSwitchTransition.js";
import { render as G } from "../../_utils/vue/render.js";
import J from "../../_internal/close/src/Close.js";
import Q from "../styles/light.js";
import U from "../../_internal/loading/src/Loading.js";
import X from "../../_internal/icon/src/Icon.js";
import Y from "../../_internal/icons/Info.js";
import Z from "../../_internal/icons/Success.js";
import ee from "../../_internal/icons/Warning.js";
import oe from "../../_internal/icons/Error.js";
import { defineComponent as ne, inject as se, computed as g, h as n } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const re = {
  info: () => n(Y, null),
  success: () => n(Z, null),
  warning: () => n(ee, null),
  error: () => n(oe, null),
  default: () => null
}, ze = ne({
  name: "Message",
  props: Object.assign(Object.assign({}, L), {
    render: Function
  }),
  setup(s) {
    const {
      inlineThemeDisabled: r,
      mergedRtlRef: t
    } = K(s), {
      props: l,
      mergedClsPrefixRef: e
    } = se(k), d = D("Message", t, e), f = F("Message", "-message", O, Q, l, e), a = g(() => {
      const {
        type: o
      } = s, {
        common: {
          cubicBezierEaseInOut: u
        },
        self: {
          padding: m,
          margin: p,
          maxWidth: h,
          iconMargin: C,
          closeMargin: v,
          closeSize: I,
          iconSize: b,
          fontSize: x,
          lineHeight: P,
          borderRadius: R,
          iconColorInfo: M,
          iconColorSuccess: $,
          iconColorWarning: z,
          iconColorError: w,
          iconColorLoading: y,
          closeIconSize: S,
          closeBorderRadius: _,
          [c("textColor", o)]: N,
          [c("boxShadow", o)]: E,
          [c("color", o)]: H,
          [c("closeColorHover", o)]: B,
          [c("closeColorPressed", o)]: W,
          [c("closeIconColor", o)]: j,
          [c("closeIconColorPressed", o)]: T,
          [c("closeIconColorHover", o)]: V
        }
      } = f.value;
      return {
        "--n-bezier": u,
        "--n-margin": p,
        "--n-padding": m,
        "--n-max-width": h,
        "--n-font-size": x,
        "--n-icon-margin": C,
        "--n-icon-size": b,
        "--n-close-icon-size": S,
        "--n-close-border-radius": _,
        "--n-close-size": I,
        "--n-close-margin": v,
        "--n-text-color": N,
        "--n-color": H,
        "--n-box-shadow": E,
        "--n-icon-color-info": M,
        "--n-icon-color-success": $,
        "--n-icon-color-warning": z,
        "--n-icon-color-error": w,
        "--n-icon-color-loading": y,
        "--n-close-color-hover": B,
        "--n-close-color-pressed": W,
        "--n-close-icon-color": j,
        "--n-close-icon-color-pressed": T,
        "--n-close-icon-color-hover": V,
        "--n-line-height": P,
        "--n-border-radius": R
      };
    }), i = r ? q("message", g(() => s.type[0]), a, {}) : void 0;
    return {
      mergedClsPrefix: e,
      rtlEnabled: d,
      messageProviderProps: l,
      handleClose() {
        var o;
        (o = s.onClose) === null || o === void 0 || o.call(s);
      },
      cssVars: r ? void 0 : a,
      themeClass: i == null ? void 0 : i.themeClass,
      onRender: i == null ? void 0 : i.onRender,
      placement: l.placement
    };
  },
  render() {
    const {
      render: s,
      type: r,
      closable: t,
      content: l,
      mergedClsPrefix: e,
      cssVars: d,
      themeClass: f,
      onRender: a,
      icon: i,
      handleClose: o,
      showIcon: u
    } = this;
    a == null || a();
    let m;
    return n("div", {
      class: [`${e}-message-wrapper`, f],
      onMouseenter: this.onMouseenter,
      onMouseleave: this.onMouseleave,
      style: [{
        alignItems: this.placement.startsWith("top") ? "flex-start" : "flex-end"
      }, d]
    }, s ? s(this.$props) : n("div", {
      class: [`${e}-message ${e}-message--${r}-type`, this.rtlEnabled && `${e}-message--rtl`]
    }, (m = le(i, r, e)) && u ? n("div", {
      class: `${e}-message__icon ${e}-message__icon--${r}-type`
    }, n(A, null, {
      default: () => m
    })) : null, n("div", {
      class: `${e}-message__content`
    }, G(l)), t ? n(J, {
      clsPrefix: e,
      class: `${e}-message__close`,
      onClick: o,
      absolute: !0
    }) : null));
  }
});
function le(s, r, t) {
  if (typeof s == "function")
    return s();
  {
    const l = r === "loading" ? n(U, {
      clsPrefix: t,
      strokeWidth: 24,
      scale: 0.85
    }) : re[r]();
    return l ? n(X, {
      clsPrefix: t,
      key: r
    }, {
      default: () => l
    }) : null;
  }
}
export {
  ze as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/message/src/Message.js
// module id = 1714
// module chunks = 67